// "Repetir pedido" do histórico do cliente no Novo Pedido do Delivery
// (30/09/2026). Antes o item voltava com o preço daquele pedido, mesmo que o
// produto tivesse mudado de preço, e produto esgotado ou apagado entrava igual.

const nomeBusca = (s) => String(s || "").trim().toLowerCase();
const centavos = (v) => Math.round((Number(v) || 0) * 100);
const qtd = (x) => Number(x?.quantidade || x?.quantity || x?.qty || 1) || 1;

// Preço de hoje de uma linha: produto (com promoção) + adicionais de hoje.
// Pizza fica com o preço gravado (o preço dela é do tamanho e dos sabores).
function precoDeHoje(item, produto, precoAtual, precoDoSubitem) {
  if (produto.product_type === "pizza") {
    return { preco: Number(item.preco || 0), promocional: !!item.is_promotional, subitems: item.subitems || [] };
  }
  // `sub.preco` é o total da linha do adicional (unitário × quantidade)
  const subitems = (item.subitems || []).map((s) => {
    const unit = precoDoSubitem(produto, s);
    return unit == null ? s : { ...s, preco: centavos(unit * qtd(s)) / 100 };
  });
  const extras = subitems.reduce((t, s) => t + (Number(s.preco) || 0), 0);
  const base = precoAtual(produto, item.combo_type || "simples");
  return { preco: centavos(base.preco + extras) / 100, promocional: base.promocional, subitems };
}

/**
 * Itens de um pedido antigo para o carrinho, com o preço de HOJE.
 * - `produtos`: os produtos à venda no Delivery (a grade do Novo Pedido).
 * - `precoAtual(produto, comboType)` → `{ preco, promocional }`: o mesmo preço
 *   do clique no produto (com a promoção ativa).
 * - `precoDoSubitem(produto, sub)` → preço unitário de hoje do adicional, ou null.
 * Pizza fica com o preço gravado (o preço dela é do tamanho e dos sabores).
 * Devolve `{ itens, mudaram, fora }`: `mudaram` = nomes com preço diferente do
 * pedido antigo; `fora` = esgotados ou que saíram do cardápio (não entram).
 */
export function montarRepeticao(itensDoPedido, { produtos, precoAtual, precoDoSubitem }) {
  const itens = [];
  const mudaram = [];
  const fora = [];
  for (const item of itensDoPedido || []) {
    const nome = item.nome || item.name || "Item";
    const produto = (produtos || []).find((p) =>
      p.id === item.id || (item.product_id && p.id === item.product_id) || nomeBusca(p.name) === nomeBusca(nome));
    if (!produto || produto.available === false) { fora.push(nome); continue; }

    const { preco, promocional, subitems } = precoDeHoje(item, produto, precoAtual, precoDoSubitem);
    // Etiqueta da balança: o valor era daquela pesagem — mudar é o esperado, não avisa.
    if (!item.etiqueta_balanca && centavos(preco) !== centavos(item.preco)) mudaram.push(nome);

    itens.push({
      ...produto,
      quantity: qtd(item),
      observation: item.observacao || "",
      subitems,
      etapas: item.etapas || [],
      combo_type: item.combo_type || null,
      sale_price: preco,
      is_promotional: promocional,
    });
  }
  return { itens, mudaram, fora };
}
